module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(_vm.$user.isAdminOrCoordinator && _vm.routeIsJobs) ? _c('button', {
    staticClass: "public",
    class: {
      'active': _vm.jobIsPublic
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleJobPublic
    }
  }, [_c('i', {
    staticClass: "fa fa-globe-asia"
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'jobs.show',
        params: {
          id: _vm.job.id
        }
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-8"
  }, [(_vm.job.user) ? _c('p', {
    staticClass: "strong no-margin"
  }, [_vm._v(_vm._s(_vm.job.user.profile.company_name))]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "truncate"
  }, [_c('strong', [_vm._v(_vm._s(_vm.job.number))]), _vm._v(" "), (_vm.jobHasEnoughDetails) ? [_vm._v("\n              - " + _vm._s(_vm.job.commodity_and_location) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('p', [_c('ul', {
    staticClass: "details"
  }, [_c('li', [_c('span', [_vm._v("Start Date:")]), _vm._v(" " + _vm._s(_vm.job.start_at))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Order:")]), _vm._v(" " + _vm._s(_vm.job.order_reference))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Quantity:")]), _vm._v(" " + _vm._s(_vm.job.quantity))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Rate:")]), _vm._v(" " + _vm._s(_vm.job.rate))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-lg-2"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    class: ("progress-bar-" + (_vm.job.status_class)),
    style: ({
      width: ((_vm.job.progress_completed_percentage) + "%")
    }),
    attrs: {
      "aria-valuemax": "100",
      "aria-valuemin": "0",
      "aria-valuenow": _vm.job.progress_completed_percentage,
      "role": "progressbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.job.progress_completed_percentage) + "% Complete")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-lg-2"
  }, [_c('span', {
    staticClass: "job-status",
    class: ("text-" + (_vm.job.status_class))
  }, [_vm._v(_vm._s(_vm.job.status_text))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4d99c739"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobItem.vue
// module id = 996
// module chunks = 0